import { Injectable } from '@angular/core';
import { Colors } from '../models/server/enums/colors';
/**
 * Classe utilitaire pour les énumérations.
 */
@Injectable({
    providedIn: 'root',
})
export class EnumHelper {
    /**
     * Convertie une valeur texte en valeur de l'Enum Color correspondante.
     * @param value : Valeur texte de la couleur.
     * @returns : valeur de l'Enum Color correspondante.
     */
    public convertColor(value: string): Colors {
        let color = Colors.None;

        if (value) {
            if (!isNaN(Number(value))) {
                if (Colors.Green.toString() == value) {
                    color = Colors.Green;
                } else if (Colors.Orange.toString() == value) {
                    color = Colors.Orange;
                } else if (Colors.Red.toString() == value) {
                    color = Colors.Red;
                } else if (Colors.Grey.toString() == value) {
                    color = Colors.Grey;
                } else if (Colors.LightBlue.toString() == value) {
                    color = Colors.LightBlue;
                } else if (Colors.DarkBlue.toString() == value) {
                    color = Colors.DarkBlue;
                }
            } else {
                if (Colors[Colors.Green].toLowerCase() == value.toLowerCase()) {
                    color = Colors.Green;
                } else if (Colors[Colors.Orange].toLowerCase() == value.toLowerCase()) {
                    color = Colors.Orange;
                } else if (Colors[Colors.Red].toLowerCase() == value.toLowerCase()) {
                    color = Colors.Red;
                } else if (Colors[Colors.Grey].toLowerCase() == value.toLowerCase()) {
                    color = Colors.Grey;
                } else if (Colors[Colors.LightBlue].toLowerCase() == value.toLowerCase()) {
                    color = Colors.LightBlue;
                } else if (Colors[Colors.DarkBlue].toLowerCase() == value.toLowerCase()) {
                    color = Colors.DarkBlue;
                }
            }
        }

        return color;
    }

    public areEquals(enumType: Object, enum1: any, enum2: any): boolean {
        // Une énum est part défaut représentée par sa representation numérique. Pour pouvoir la comparer à une enum représentée
        // par sa valeur textuelle, on transforme la valeur textuelle de l'enum en valeur numérique (enumType[valeur_textuelle]).
        let operande1 = enum1;
        const operande2 = enum2;

        if (typeof enum1 !== 'number' && !!enum1) {
            if (this.isNumber(enum1)) {
                // Cas où l'opérateur 1 est exprimé sous la forme numérique de l'enum mais de type texte.
                operande1 = parseInt(enum1);
            } else {
                // Cas où l'opérateur 1 est exprimé sous la forme textuelle de l'enum.
                operande1 = enumType[enum1.toString()];
            }
        }

        return operande1 === operande2;
    }

    private isNumber(str: string): boolean {
        if (typeof str !== 'string') {
            return false;
        }

        if (str.trim() === '') {
            return false;
        }

        return !Number.isNaN(Number(str));
    }
}
